import { Application } from '@hotwired/stimulus';
import CharacterCountController from './controllers/character_count_controller';
import CampaignPickerController from './controllers/campaign_picker_controller';
import ChunkingController from './controllers/chunking_controller';
import CollapsibleController from './controllers/collapsible_controller';
import ConfirmController from './controllers/confirm_controller';
import DismissController from './controllers/dismiss_controller';
import DocumentSourceController from './controllers/document_source_controller';
import FeedbackController from './controllers/feedback_controller';
import FieldsController from './controllers/fields_controller';
import FiltersController from './controllers/filters_controller';
import ImportStatusController from './controllers/import_status_controller';
import ModeController from './controllers/mode_controller';
import PasswordVisibilityController from './controllers/password_visibility_controller';
import PurchaseController from './controllers/purchase_controller';
import Select2Controller from './controllers/select2_controller';
import StripeController from './controllers/stripe_controller';
import StarRatingController from './controllers/star_rating_controller';
import DirectTextUploadController from './controllers/direct_text_upload_controller';
import BookController from './controllers/book_controller';
import MfViewerController from './controllers/mf_viewer_controller';
import DocHelpController from './controllers/doc_help_controller';
import TagInputController from './controllers/tag_input_controller';
import AutoOpenController from './controllers/auto_open_controller';
import ReaderPositionController from './controllers/reader_position_controller';
import ReaderCheckpointSyncController from './controllers/reader_checkpoint_sync_controller';
import ClipboardController from './controllers/clipboard_controller';
import DetailsDismissController from './controllers/details_dismiss_controller';
import ProcessingStatusController from './controllers/processing_status_controller';
import DisableOnSubmitController from './controllers/disable_on_submit_controller';

const application = Application.start();
application.debug = false;
window.Stimulus = application;

application.register('character-count', CharacterCountController);
application.register('campaign-picker', CampaignPickerController);
application.register('chunking', ChunkingController);
application.register('collapsible', CollapsibleController);
application.register('confirm', ConfirmController);
application.register('dismiss', DismissController);
application.register('document-source', DocumentSourceController);
application.register('feedback', FeedbackController);
application.register('fields', FieldsController);
application.register('filters', FiltersController);
application.register('import-status', ImportStatusController);
application.register('mode', ModeController);
application.register('password-visibility', PasswordVisibilityController);
application.register('purchase', PurchaseController);
application.register('select2', Select2Controller);
application.register('stripe', StripeController);
application.register('star-rating', StarRatingController);
application.register('direct-text-upload', DirectTextUploadController);
application.register('book', BookController);
application.register('mf-viewer', MfViewerController);
application.register('doc-help', DocHelpController);
application.register('tag-input', TagInputController);
application.register('auto-open', AutoOpenController);
application.register('reader-position', ReaderPositionController);
application.register('reader-checkpoint-sync', ReaderCheckpointSyncController);
application.register('clipboard', ClipboardController);
application.register('details-dismiss', DetailsDismissController);
application.register('processing-status', ProcessingStatusController);
application.register('disable-on-submit', DisableOnSubmitController);

export { application };
